import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import PagingBar from '../../components/PagingBar.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const BudgetCapitalTopPart4 = ReactRouterDOM.withRouter(function ({ budgetCapital }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [budgetCapital]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, budgetCapital]);

  const loadCount = async function () {
    try {
      const args = {};
      if (budgetCapital.budgetCapitalId !== null && budgetCapital.budgetCapitalId !== undefined) {
        args.budgetCapitalBudgetCapitalId = budgetCapital.budgetCapitalId;
      }
      setCount(await ApiService.getCountBudgetCapitalAudits(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (budgetCapital.budgetCapitalId !== null && budgetCapital.budgetCapitalId !== undefined) {
        args.budgetCapitalBudgetCapitalId = budgetCapital.budgetCapitalId;
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBudgetCapitalAudits(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.budgetCapitalAuditId,
      data: [
        record.datetime,
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.userFirstName, record.userLastName ]),
        record.janAmount,
        record.janOldAmount,
        record.febAmount,
        record.febOldAmount,
        record.marAmount,
        record.marOldAmount,
        record.aprAmount,
        record.aprOldAmount,
        record.mayAmount,
        record.mayOldAmount,
        record.junAmount,
        record.junOldAmount,
        record.julAmount,
        record.julOldAmount,
        record.augAmount,
        record.augOldAmount,
        record.sepAmount,
        record.sepOldAmount,
        record.octAmount,
        record.octOldAmount,
        record.novAmount,
        record.novOldAmount,
        record.decAmount,
        record.decOldAmount,
      ],
      record: record
    })));
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  return (
    <div>
      <div>
        <Grid
          contextualActions={[
          ]}
          fields={[
            {
              label: words.datetime,
              type: 'datetime',
              bindIndex: 0,
              secondaryField: {
                type: 'string',
                bindIndex: 1,
              },
            },
            {
              label: words.jan,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 2,
              comparativeField: {
                type: 'decimal',
                bindIndex: 3,
              },
            },
            {
              label: words.feb,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 4,
              comparativeField: {
                type: 'decimal',
                bindIndex: 5,
              },
            },
            {
              label: words.mar,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 6,
              comparativeField: {
                type: 'decimal',
                bindIndex: 7,
              },
            },
            {
              label: words.apr,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 8,
              comparativeField: {
                type: 'decimal',
                bindIndex: 9,
              },
            },
            {
              label: words.may,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 10,
              comparativeField: {
                type: 'decimal',
                bindIndex: 11,
              },
            },
            {
              label: words.jun,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 12,
              comparativeField: {
                type: 'decimal',
                bindIndex: 13,
              },
            },
            {
              label: words.jul,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 14,
              comparativeField: {
                type: 'decimal',
                bindIndex: 15,
              },
            },
            {
              label: words.aug,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 16,
              comparativeField: {
                type: 'decimal',
                bindIndex: 17,
              },
            },
            {
              label: words.sep,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 18,
              comparativeField: {
                type: 'decimal',
                bindIndex: 19,
              },
            },
            {
              label: words.oct,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 20,
              comparativeField: {
                type: 'decimal',
                bindIndex: 21,
              },
            },
            {
              label: words.nov,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 22,
              comparativeField: {
                type: 'decimal',
                bindIndex: 23,
              },
            },
            {
              label: words.dec,
              type: 'decimal',
              alignment: 'right',
              bindIndex: 24,
              comparativeField: {
                type: 'decimal',
                bindIndex: 25,
              },
            },
          ]}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
    </div>
  );
})

export default BudgetCapitalTopPart4;
